import React from 'react';
import PropTypes from 'prop-types';
import DropzoneComponent from 'react-dropzone-component';
import Grid from '@material-ui/core/Grid';
import Button from './Button';
import { DispatchDialogContext } from '../providers/DialogProvider/DialogContext';
import { getCookie } from '../services/useAuthentication';

const propTypes = {
  uri: PropTypes.string.isRequired,
};

function Dropzone(props) {
  const { uri } = props;
  const [dropzone, setDropzone] = React.useState(null);
  const [showFileButton, setShowFileButton] = React.useState(true);
  const [showUploadButton, setShowUploadButton] = React.useState(false);
  const [showClearButton, setShowClearButton] = React.useState(false);
  const dialog = React.useContext(DispatchDialogContext);

  // Leer el token en cada render (no a nivel de módulo) para evitar tokens
  // caducados cuando el usuario inicia sesión sin recargar la página.
  const token = getCookie('sessionId');
  // No enviar Cache-Control/X-Requested-With: Dropzone.js los agrega por
  // defecto y no estan permitidos por el CORS del API, lo que rompe el
  // preflight. Solo dejamos Authorization (si que esta permitido).
  const headers = {
    Authorization: `Bearer ${token}`,
    'Cache-Control': null,
    'X-Requested-With': null,
  };

  // Dropzone.js hace su propia petición XHR y NO pasa por axios, así que hay
  // que anteponer manualmente la URL base del API para que no apunte al origen
  // del frontend.
  const apiBase = process.env.RAZZLE_API_URL || '';
  const fullUrl = `${apiBase}${uri}`;

  const djsConfig = {
    previewTemplate: `
      <div class="files dz-preview dz-file-preview">
        <div class="file-row dz-file-preview-template">
          <div>
            <span class="preview dz-image">
              <div data-dz-thumbnail-bg></div>
            </span>
          </div>
          <div class="dz-details">
            <div class="dz-details-header">
              <div>
                <p class="dz-filename" data-dz-name></p>
                <p class="dz-size" data-dz-size></p>
              </div>
              <div class="dz-details-header-icon">
                <div class="dz-status"><span class="material-icons"></span></div>
              </div>
            </div>
            <div>
              <div class="progress progress-striped active dz-progress" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0">
                <div class="progress-bar progress-bar-success dz-upload" style="width:0%;" data-dz-uploadprogress></div>
              </div>
            </div>
            <div>
              <div class="dz-error-message"><span data-dz-errormessage></span></div>
            </div>
          </div>
        </div>
      </div>
    `,
    url: fullUrl,
    thumbnailWidth: 150,
    autoProcessQueue: false,
    maxFilesize: 0.5,
    clickable: '.fileAdded',
    headers,
  };

  const componentConfig = {
    postUrl: fullUrl,
  };

  /* eslint-disable */
  // TODO: Refactorizar la función para seguir las reglas de ESLint sin causar errores en el renderizado
  function thumbnail(file, dataUrl) {
    var j, len, ref, thumbnailElement;
    if (file.previewElement) {
      file.previewElement.classList.remove('dz-file-preview');
      ref = file.previewElement.querySelectorAll('[data-dz-thumbnail-bg]');
      for (j = 0, len = ref.length; j < len; j++) {
        thumbnailElement = ref[j];
        thumbnailElement.alt = file.name;
        thumbnailElement.style.backgroundImage = 'url("' + dataUrl + '")';
      }
      return setTimeout(((function(_this) {
        return function() {
          return file.previewElement.classList.add('dz-image-preview');
        };
      })(this)), 1);
    }
  }
  /* eslint-enable */

  function changeIcon(file, icon) {
    const elementCloset = file.previewElement;
    const element = elementCloset.querySelectorAll('.dz-status span');
    element[0].innerText = icon;
  }

  function sendImages() {
    dropzone.processQueue();
  }

  function success(file) {
    changeIcon(file, 'check');
  }

  function error(file) {
    changeIcon(file, 'close');
  }

  function queuecomplete() {
    setShowFileButton(true);
    setShowClearButton(true);
    dialog({
      type: 'success',
      content: 'Se termino de subir todas las imágenes',
    });
  }

  function showFile(file) {
    changeIcon(file, 'cloud_upload');
    setShowUploadButton(true);
    setShowClearButton(true);
  }

  function processing() {
    setShowUploadButton(false);
    setShowFileButton(false);
    setShowClearButton(false);
  }

  function resetImages() {
    setShowUploadButton(false);
    setShowClearButton(false);
    dropzone.removeAllFiles();
  }

  const eventHandlers = {
    init: (dz) => {
      setDropzone(dz);
      dz.on('success', (file) => {
        success(file);
        dz.processQueue();
      });
      dz.on('error', (file) => {
        error(file);
        dz.processQueue();
      });
    },
    processing,
    addedfile: showFile,
    thumbnail,
    queuecomplete,
  };

  return (
    <>
      <Grid container spacing={1} item xs>
        <Grid item xs="auto">
          {showFileButton && (
            <Button className="fileAdded" color="primary" square>Cargar imágenes</Button>
          )}
        </Grid>
        <Grid item xs="auto">
          {showUploadButton && (
            <Button onClick={sendImages} color="success" square>Enviar imágenes</Button>
          )}
        </Grid>
        <Grid item xs="auto">
          {showClearButton && (
            <Button onClick={resetImages} color="error" square>Limpiar</Button>
          )}
        </Grid>
      </Grid>

      <DropzoneComponent
        config={componentConfig}
        eventHandlers={eventHandlers}
        djsConfig={djsConfig}
      >
        <span className="dz-message " />
      </DropzoneComponent>
    </>
  );
}

Dropzone.propTypes = propTypes;

export default Dropzone;
